module.exports={render:function (){with(this) {
  return _m(0)
}},staticRenderFns: [function (){with(this) {
  return _h('div')
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dbfunctions.vue
 ** module id = 86
 ** module chunks = 2
 **/